export default __webpack_public_path__ + "static/6-5e4e4b031fe8619d8300a90e8b2aa2df.jpg";